import React from 'react';
import Scroll from 'react-scroll';
import Textinput from './textinput';
import SelectFreights from './selectFreights';
import {
    isEveryValid,
    isLengthValid,
    isDecimalValid,
    isIntegerValid,
    scrollToError,
    firstError,
} from '../services/utils';
import { getContactTemplates } from '../services/api';
import { ContractTypes } from '../constants/contract';

const Contracts = {
    PAPER: 'Paper',
    PHYSICAL: 'Physical',
};

const CURRENCIES = ['USD', 'EUR', 'NOK', 'DKK'];

class ManageProductPopup extends React.Component {
    constructor(props) {
        super(props);

        this.contactTemplates = [];
        this.initialState = {
            id: null,
            name: '',
            short_name: '',
            min_size: '',
            max_size: '',
            min_price: '',
            max_price: '',
            unit_name: 'Metric Ton',
            units_name: 'Metric Ton',
            commission: '',
            commission_type: 'percentage',
            currency_id: CURRENCIES[0], // USD
            market_id: '',
            contract: '',
            indices_frequency_type: 'weekly',
            contract_type: ContractTypes.OTC,
            contract_filename: '',
            code: null,
            freights: [],
            validation: {
                name: false,
                short_name: false,
                min_size: false,
                max_size: false,
                min_price: false,
                max_price: false,
                commission: false,
                contract_filename: false,
                contract_type: true,
                code: true,
            },
            submitCliked: false,
        };

        this.state = this.initialState;
        this.fetched = false;
        this.templFetched = false;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != this.props)
            this.fillForm(nextProps);
    }

    fillForm(props) {
        if (!this.fetched) {
            let stateToFill = {},
                validation = {};

            if ('data' in props.data) {
                this.fetched = true;
            }

            if (props.data.mode === 'create') {
                stateToFill = {
                    market_id: props.data.market_id || '',
                    contract: Contracts.PAPER,
                    freights: [],
                };
            } else {
                stateToFill = props.data.data;
                if (stateToFill) {
                    stateToFill.contract =
                        stateToFill.contract_type !== ContractTypes.PHYSICAL ? Contracts.PAPER : Contracts.PHYSICAL;
                    stateToFill.freights = stateToFill.freights || [];
                    for (let key in this.state.validation) {
                        validation[key] = !!(key in stateToFill && stateToFill[key]);
                        if (key === 'code' && stateToFill.contract_type !== ContractTypes.CME) {
                            validation['code'] = true;
                        }
                    }
                    stateToFill.validation = validation;
                }
            }

            this.setState(stateToFill);
        }
    }

    handleChange = e => {
        const { name, value } = e.target;

        let stateProps = {};
        switch (name) {
            case 'is_cme_contract_type':
                stateProps = {
                    contract_type:
                        this.state.contract === Contracts.PAPER
                            ? this.state.contract_type === ContractTypes.CME
                                ? ContractTypes.OTC
                                : ContractTypes.CME
                            : ContractTypes.PHYSICAL,
                    code:
                        this.state.contract === Contracts.PAPER && this.state.contract_type !== ContractTypes.CME
                            ? this.state.code
                            : null,
                };
                break;
            case 'contract_type':
                stateProps = {
                    contract_type: value === Contracts.PAPER ? ContractTypes.OTC : ContractTypes.PHYSICAL,
                    contract: value,
                    code: null,
                };
                break;
            case 'units_name':
                stateProps = {
                    units_name: value,
                    unit_name: value,
                };
                break;
            default:
                stateProps = {
                    [name]: value,
                };
        }

        this.setState(stateProps, () => {
            this.validateField(name, value);
            if (['is_cme_contract_type', 'contract_type'].indexOf(name) > -1) {
                this.validateField('code', this.state.code);
            }
        });
    };

    handleChangeFreights = freights => {
        this.setState({ freights });
    };

    validateField(fieldName, value) {
        const { contract, contract_type } = this.state;
        const stringInputs = ['name', 'short_name'];
        const intInputs = ['min_size', 'max_size', 'min_price', 'max_price'];
        if (this.state.validation[fieldName] != undefined) {
            if (stringInputs.indexOf(fieldName) !== -1) {
                value = isLengthValid(value, fieldName);
            } else if (fieldName === 'commission') {
                value = isIntegerValid(value) || isDecimalValid(value);
            } else if (intInputs.indexOf(fieldName) !== -1) {
                value = isIntegerValid(value);
            } else if (fieldName === 'code' && (contract !== Contracts.PAPER || contract_type !== ContractTypes.CME)) {
                value = true;
            }
            this.setState({
                validation: {
                    ...this.state.validation,
                    [fieldName]: value && (typeof value !== 'string' || value.trim()) ? true : false,
                },
            });
        }
    }

    handleSubmit(mode) {
        const data = this.state;
        const isValid = isEveryValid(data.validation);
        const errorField = firstError(data.validation);
        this.setState({
            ...this.state,
            submitCliked: true,
        });
        if (isValid) {
            const transformedData = {
                ...data,
                min_size: +data.min_size,
                max_size: +data.max_size,
                min_price: +data.min_price,
                max_price: +data.max_price,
                commission: +data.commission,
                freights: data.contract_type === ContractTypes.PHYSICAL ? data.freights : [],
            };
            this.props.manageProduct(mode, transformedData, this.props.autoLogin, this.clearForm);
        } else {
            this.props.showPopup({
                title: 'Error',
                content: 'Please make sure all the information is correct and try again.',
                buttonText: 'Dismiss',
            });
            scrollToError(errorField, 'product-popup-scroll-container');
        }
    }

    closePopup(e) {
        if (e.target.getAttribute('name') === 'manageProductPopup') {
            this.props.hidePopup();
            this.clearForm();
        }
    }

    getContactTemplates() {
        if (!this.templFetched) {
            this.templFetched = true;
            getContactTemplates()
                .then(resp => {
                    this.contactTemplates = resp.data;
                })
                .catch(er => console.log(er));
        }
    }

    clearForm = () => {
        this.setState(this.initialState);
        this.fetched = false;
        this.templFetched = false;
    };

    render() {
        const { user, visible } = this.props;
        const { mode } = this.props.data;
        const { submitCliked } = this.state;
        if (!this.contactTemplates.length && user.isLoggedIn) {
            this.getContactTemplates();
        }
        return (
            <div
                onClick={this.closePopup.bind(this)}
                style={{ display: visible ? 'block' : 'none' }}
                name="manageProductPopup"
                className="admin-product-container generic-popup-container"
                id="product-popup-scroll-container"
            >
                <div className="admin-product-inner">
                    <center>
                        <h2 className="title">{mode == 'create' ? 'Create' : 'Update'} product</h2>
                    </center>

                    <Textinput
                        label="Product name"
                        name="name"
                        value={this.state.name}
                        onChange={this.handleChange}
                        required
                        invalid={!this.state.validation.name && submitCliked}
                        type="text"
                    />

                    <Textinput
                        label="Short name"
                        name="short_name"
                        value={this.state.short_name}
                        onChange={this.handleChange}
                        maxLength={20}
                        invalid={!this.state.validation.short_name && submitCliked}
                        type="text"
                        required
                    />

                    <Textinput
                        label="Min size"
                        name="min_size"
                        value={this.state.min_size}
                        onChange={this.handleChange}
                        invalid={!this.state.validation.min_size && submitCliked}
                        type="number"
                        required
                    />

                    <Textinput
                        label="Max size"
                        name="max_size"
                        value={this.state.max_size}
                        onChange={this.handleChange}
                        invalid={!this.state.validation.max_size && submitCliked}
                        type="number"
                        required
                    />

                    <Textinput
                        label="Min price"
                        name="min_price"
                        value={this.state.min_price}
                        onChange={this.handleChange}
                        invalid={!this.state.validation.min_price && submitCliked}
                        type="number"
                        required
                    />

                    <Textinput
                        label="Max price"
                        name="max_price"
                        value={this.state.max_price}
                        onChange={this.handleChange}
                        required
                        invalid={!this.state.validation.max_price && submitCliked}
                        type="number"
                    />

                    <div className="field-wrap">
                        <label htmlFor="units_name" className="labelactive">
                            Units<span className="req">*</span>
                        </label>
                        <select name="units_name" onChange={this.handleChange} value={this.state.units_name || ''}>
                            <option value="Metric Ton">Metric Ton</option>
                            <option value="Short Ton">Short Ton</option>
                        </select>
                    </div>

                    <div className="popup-column-holder">
                        <div className="popup-column">
                            <Textinput
                                label="Commission"
                                name="commission"
                                value={this.state.commission}
                                onChange={this.handleChange}
                                required
                                invalid={!this.state.validation.commission && submitCliked}
                                type="number"
                                inputProcessing="decimalTwoDigits"
                            />
                        </div>
                        <div className="popup-column">
                            <select
                                name="commission_type"
                                onChange={this.handleChange}
                                value={this.state.commission_type || ''}
                            >
                                <option value="percentage">Percentage on each side</option>
                                <option value="fixed">Fixed on each side</option>
                            </select>
                        </div>
                    </div>

                    <div className="field-wrap">
                        <label htmlFor="currency_id" className="labelactive">
                            Currency<span className="req">*</span>
                        </label>
                        <select name="currency_id" onChange={this.handleChange} value={this.state.currency_id || ''}>
                            {CURRENCIES.map(currency => (
                                <option value={currency}>{currency}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-wrap">
                        <label htmlFor="indices_frequency_type" className="labelactive">
                            Indices Schedule<span className="req">*</span>
                        </label>
                        <select
                            name="indices_frequency_type"
                            onChange={this.handleChange}
                            value={this.state.indices_frequency_type}
                        >
                            <option value="weekly">Weekly</option>
                            <option value="daily">Daily</option>
                        </select>
                    </div>

                    <div
                        className={`field-wrap ${
                            !this.state.validation.contract_filename && submitCliked ? 'error' : ''
                        }`}
                    >
                        <Scroll.Element name="contract_filename" />
                        <label htmlFor="contract_filename" className="labelactive">
                            Contract template<span className="req">*</span>
                        </label>
                        <select
                            name="contract_filename"
                            onChange={this.handleChange}
                            value={this.state.contract_filename || ''}
                        >
                            <option value=""> -- choose contract filename -- </option>
                            {this.contactTemplates.length
                                ? this.contactTemplates.map((item, i) => (
                                      <option key={`contact${item}`} value={item}>
                                          {item}
                                      </option>
                                  ))
                                : null}
                        </select>
                    </div>

                    <div className="field-wrap">
                        <label
                            htmlFor="contract_type"
                            className={
                                'labelactive ' + (!this.state.validation.contract_type && submitCliked ? 'error' : '')
                            }
                        >
                            Contract type<span className="req">*</span>
                        </label>
                        <select name="contract_type" onChange={this.handleChange} value={this.state.contract || ''}>
                            <option value={Contracts.PAPER}>{Contracts.PAPER}</option>
                            <option value={Contracts.PHYSICAL}>{Contracts.PHYSICAL}</option>
                        </select>
                    </div>

                    {this.state.contract !== Contracts.PHYSICAL ? (
                        <div className="field-wrap">
                            <input
                                type="checkbox"
                                name="is_cme_contract_type"
                                id="contract_type"
                                checked={
                                    this.state.contract === Contracts.PAPER &&
                                    this.state.contract_type === ContractTypes.CME
                                        ? 'checked'
                                        : ''
                                }
                                onChange={this.handleChange}
                            />
                            <label htmlFor="is_cme_contract_type" className="checkbox-label">
                                is CME
                            </label>
                        </div>
                    ) : (
                        <div className="field-wrap">
                            <SelectFreights
                                freights={this.props.freights}
                                selectedFreights={this.state.freights}
                                onChange={this.handleChangeFreights}
                            />
                        </div>
                    )}

                    {this.state.contract === Contracts.PAPER && this.state.contract_type === ContractTypes.CME ? (
                        <Textinput
                            label="Contract code"
                            name="code"
                            value={this.state.code}
                            onChange={this.handleChange}
                            invalid={!this.state.validation.code && submitCliked}
                            type="text"
                            required
                        />
                    ) : null}

                    <button type="submit" onClick={this.handleSubmit.bind(this, mode)} className="button button-block">
                        {mode === 'create' ? 'Create' : 'Update'}
                    </button>
                </div>
            </div>
        );
    }
}

export default ManageProductPopup;



// WEBPACK FOOTER //
// ./source/components/manageProductPopup.js